import React from "react";
import { Typography, Link } from '@mui/material';
import { LockOutlined as Icon } from '@mui/icons-material';
import { ProductEnabledProps } from '../shared/types';

function withProductEnabled<P extends object>(
    WrappedComponent: React.ComponentType<P>,
    missingCoId?: unknown,
): React.ComponentType<P & ProductEnabledProps> {
    return class extends React.Component<P & ProductEnabledProps> {

    render() {
        let style = {fontSize: '16pt'};
      if(!this.props.productEnabled){
          return <div style={{color: '#888'}}>
              <Icon style={{fontSize: "20em"}}/>
              <Typography style={style}>
                To manage your catalog through Logicbroker you will need to be a member of <Link target="_blank" rel="noopener noreferrer" href='https://www.logicbroker.com/connected-commerce-network/'>Connected Commerce Network™</Link>.
              </Typography>
              <Typography style={style}>
                Ready to join? <Link target="_blank" rel="noopener noreferrer" href='https://info.logicbroker.com/connected-commerce-network-brands'>Contact us today</Link>
              </Typography>
          </div>;
      }
      return <WrappedComponent {...(this.props as P)} />;
    }
  };
}

const withProductEnabledExport = <P extends object>(
    component: React.ComponentType<P>,
    missingCoId?: unknown,
): React.ComponentType<P & ProductEnabledProps> => withProductEnabled(component, missingCoId);
export default withProductEnabledExport;
